<template>
  <div>

    <!-- rakuchat -->
    <RCcomplainList v-if="complainDetail.type == 'RAKUCHAT'" :complainDetail="complainDetail" />
    <!-- chatwork -->
    <CWcomplainList v-if="complainDetail.type == 'CHATWORK'" :complainDetail="complainDetail" />
  </div>
</template>
<script>
import RCcomplainList from './complainList/RCcomplainList'
import CWcomplainList from './complainList/CWcomplainList.vue'
export default {
  components: {
    RCcomplainList,
    CWcomplainList
  },
  props: {
    complainDetail: { type: Object }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped></style>